import { Dispatch } from 'redux'
import {
  apiRequest,
  apiFailure,
  getOpeningHours as getOpeningHoursReducer,
  sendFeedback as sendFeedbackReducer,
} from 'reducers/actionMenu.reducer'
import { actionMenuService } from 'services/actionMenu.service'
import IFeedback from 'models/IFeedback'
import IOpeningHours from 'models/IOpeningHours'

export const getOpeningHours = (slug: string) => async (dispatch: Dispatch) => {
  try {
    dispatch(apiRequest())

    const response = await actionMenuService.getOpeningHours(slug)
    if (response) {
      dispatch(
        getOpeningHoursReducer({
          success: response.success,
          message: response.message,
          openingHours: response.data as IOpeningHours[],
        })
      )
    }
  } catch (error) {
    dispatch(apiFailure())
  }
}

export const sendFeedback =
  (feedback: IFeedback) => async (dispatch: Dispatch) => {
    try {
      dispatch(apiRequest())

      const response = await actionMenuService.sendFeedback(feedback)
      if (response) {
        dispatch(sendFeedbackReducer(response))
      }
    } catch (error) {
      dispatch(apiFailure())
    }
  }
